<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    추가 프리미엄 회원
                    <el-button class="title_btn" @click="moveCreate()" type="primary">등록</el-button>
                </div>
                <div class="list-content">
                    <member-list-component :memberType="`premium`"></member-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import MemberListComponent from "@/components/member/MemberListComponent";

export default {
    name: 'Member',
    mixins: [],
    components: {MemberListComponent},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        moveCreate(){
            this.$router.replace(this.$route.path);
            this.$router.push(`/student/premium/create`);
        },
        // download() {
        //     const anchor = document.createElement('a');
        //     anchor.href = url;
        //     anchor.style.display = 'none';
        //     anchor.target = '_blank'
        //     document.body.appendChild(anchor);
        //     anchor.click();
        // },
    },
    watch: {},
}
</script>
